import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import toast from '../../shared/Toast';
import { useRespondToRsvpMutation } from '../../../app/Slices/SevenDayApiSlice';
import { RsvpStatus } from '../../types/reservation';

const RsvpPage = () => {
    const { bookingId, rsvpId } = useParams();
    const queryParameters = new URLSearchParams(window.location.search);
    const status = `${queryParameters.get('response')}` as RsvpStatus;
    const [respond] = useRespondToRsvpMutation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!rsvpId || !['accepted', 'declined'].includes(status)) {
            navigate(`/login`, { replace: true });
            return;
        }
        respond({ bookingId: Number(bookingId), rsvpId, status })
            .then((data: any) => {
                if (data?.error) {
                    toast.error(data.error.data.message);
                } else {
                    toast.success(`RSVP request ${status} successsfully.`);
                }
            })
            .catch(() => {
                toast.error('Failed to respond to RSVP. Please try again.');
            })
            .finally(() => {
                navigate(`/reservations/reservation/${bookingId}`, {
                    replace: true,
                });
            });
    }, []);

    return <></>;
};
export default RsvpPage;
